export default "__VITE_ASSET__Ftvhya7K__"